// extracted by mini-css-extract-plugin
module.exports = {"pageTop":"PageTopText_pageTop__9Anl3","inner":"PageTopText_inner__TiuJU","title":"PageTopText_title__vD91g","text":"PageTopText_text__C78f8"};